import React, { Component } from "react";
import {
  EkoForm,
  EkoFormButton,
  EkoFormSelect,
} from "../../components/elements/EkoForm";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { toastr } from "react-redux-toastr";

import HelperContainer from "../../util/HelperContainer";
import EkoSpinner from "../../components/elements/EkoSpinner";
import Util from "../../util/Util";
import Api from "../../util/Api";
import EkoModal from "../../components/elements/EkoModal";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { empty } from "rxjs/Observer";
import { FETCH_DECLARATION_TYPES } from "../../actions/types";
import axios from "axios";
import { ROOT_URL } from "../../actions";

class SoftwareSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      loading: false,
      currentCompanySettings: {},
      newCompanySettings: {},
      eInformation: {},
      company: {},
      taxIdentityQueryLogModal: false,
      taxIdentityQueryLogLoading: false,
      taxIdentityQueryLogList: [],
      taxIdentityTermsModal: false,
      taxIdentityQueryAccepted: false,
      pendingEnableTaxIdentityQuery: false,
      // currencyRate
    };
  }
  componentWillMount() {
    let errors = {};
    this.setState({ errors: errors });
  }
  async componentDidMount() {
    await this.getCurrentCompanySettings();
    await this.getCompanyEinformation();
    this.props.changePageTitle("Yazılım Ayarları");
    this.setState({ loading: false });
  }
  async getCurrentCompanySettings() {
    try {
      this.setState({ loading: true });
      const response = await axios.get(ROOT_URL + "/getCompanySettings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const currentCompanySettings = response.data.result || {};
      localStorage.setItem(
        "company_settings",
        JSON.stringify(currentCompanySettings),
      );
      const isTaxIdentityQueryEnabled =
        parseInt(currentCompanySettings.tax_identity_query, 10) === 1;
      this.setState({
        currentCompanySettings,
        taxIdentityQueryAccepted: isTaxIdentityQueryEnabled,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      console.error("Error fetching company settings:", error);
      toastr.error("Ayarlar yüklenirken bir hata oluştu.");
    }
  }
  async getCompanyEinformation() {
    let companyId = JSON.parse(localStorage.getItem("user")).company_id;
    Api.get("/eInformation/show/" + companyId, (response, err) => {
      if (typeof response.eInformation.id !== "undefined") {
        this.setState({ eInformation: response.eInformation });
      }
    });

    Api.get("/company", (response, err) => {
      this.setState({ company: response.company });
    });
  }
  onInputChange(id, value) {
    let newCompanySettings = this.state.newCompanySettings || {};
    newCompanySettings[id] = value;
    this.setState({ newCompanySettings });
    console.log(newCompanySettings);
  }
  onSaveForm() {
    this.setState({ loading: true });
    let newCompanySettings = this.state.newCompanySettings;
    Api.post(
      "/updateCompanySettings",
      newCompanySettings,
      (response, postErrors) => {
        if (response.result == 1) {
          toastr.success("Başarılı", "Ayarlarınız güncellendi");
          this.setState({ loading: false });
          this.getCurrentCompanySettings();
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          toastr.error("Hata", "Ayarlarınız güncellenemedi");
          this.setState({ loading: false });
        }
        if (postErrors) {
          this.setState({ errors: postErrors });
          this.setState({ loading: false });
        }
      },
    );
  }

  openTaxIdentityQueryLogModal() {
    this.setState({
      taxIdentityQueryLogModal: true,
      taxIdentityQueryLogLoading: true,
      taxIdentityQueryLogList: [],
    });

    Api.get("/company/getTaxIdentityQueryLog", (response, error) => {
      if (error) {
        this.setState({ taxIdentityQueryLogLoading: false });
        if (error.system_error) {
          toastr.error("Hata", error.system_error);
        } else {
          toastr.error("Hata", "Kayıtlar alınırken hata oluştu.");
        }
        return;
      }

      this.setState({
        taxIdentityQueryLogLoading: false,
        taxIdentityQueryLogList: response?.list || [],
      });
    });
  }

  closeTaxIdentityQueryLogModal() {
    this.setState({ taxIdentityQueryLogModal: false });
  }

  openTaxIdentityTermsModal() {
    this.setState({ taxIdentityTermsModal: true });
  }

  closeTaxIdentityTermsModal() {
    this.setState({ taxIdentityTermsModal: false, pendingEnableTaxIdentityQuery: false });
  }

  acceptTaxIdentityTerms() {
    this.setState(
      {
        taxIdentityQueryAccepted: true,
        taxIdentityTermsModal: false,
      },
      () => {
        if (this.state.pendingEnableTaxIdentityQuery) {
          this.setState({ pendingEnableTaxIdentityQuery: false }, () => {
            this.onInputChange("tax_identity_query", 1);
          });
        }
      },
    );
  }

  onTaxIdentityTermsCheckboxChange(e, isTaxIdentityQueryEnabled) {
    if (isTaxIdentityQueryEnabled) {
      return;
    }
    const checked = !!e.target.checked;
    if (checked) {
      this.openTaxIdentityTermsModal();
    } else {
      this.setState({ taxIdentityQueryAccepted: false });
    }
  }

  onTaxIdentityQuerySettingChange(e) {
    const nextValue = parseInt(e.target.value, 10);
    if (nextValue === 1 && this.state.taxIdentityQueryAccepted !== true) {
      toastr.error("Uyarı", "Koşulları kabul etmeden servisi açamazsınız.");
      this.setState({ pendingEnableTaxIdentityQuery: true }, () => {
        this.openTaxIdentityTermsModal();
      });
      return;
    }
    if (nextValue === 1) {
      this.setState({ taxIdentityQueryAccepted: true });
    }
    this.onInputChange("tax_identity_query", nextValue);
  }

  render() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center", paddingTop: "100px" }}>
          <EkoSpinner />
          <p>Ayarlar yükleniyor...</p>
        </div>
      );
    }
    const taxIdentityQueryValue =
      this.state.newCompanySettings &&
      this.state.newCompanySettings.tax_identity_query !== undefined
        ? this.state.newCompanySettings.tax_identity_query
        : this.state.currentCompanySettings.tax_identity_query !== undefined
          ? this.state.currentCompanySettings.tax_identity_query
          : 1;
    const isTaxIdentityQueryEnabled = taxIdentityQueryValue === 1;
    return (
      <div>
        <a
          style={{ bottom: "6px", position: "relative", color: "grey" }}
          onClick={Util.backButton.bind(this, "/dashboard")}
        >
          <i className="fa fa-arrow-left"></i> Geri Dön
        </a>
        <div className="portlet light">
          <div className="portlet-title">
            <div className="caption font-dark">
              <span className="caption-subject bold uppercase">
                Yazılım Ayarları
              </span>
            </div>
          </div>
          <div className="portlet-body">
            <EkoForm hortizonal={false} formId="add-new-declarations">
              <div className="row">
                <div className={"col-md-4"} style={{ height: "138px" }}>
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{ fontWeight: 600, fontSize: 12, marginBottom: 8 }}
                    >
                      Barkod Kullanımı
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange("is_barcode_usage", e.target.value)
                      }
                      style={{}}
                    >
                      <option
                        value={0}
                        selected={
                          this.state.currentCompanySettings.is_barcode_usage ==
                          0
                        }
                      >
                        Kapalı
                      </option>
                      <option
                        value={1}
                        selected={
                          this.state.currentCompanySettings.is_barcode_usage ==
                          1
                        }
                      >
                        Açık
                      </option>
                    </select>
                    <br />
                    <br />
                  </div>
                </div>
                <div className="col-md-4" style={{ height: "138px" }}>
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    }}
                  >
                    <h4
                      style={{
                        marginTop: 0,
                        marginBottom: 15,
                        fontWeight: "bold",
                        fontSize: 14,
                        letterSpacing: 0.5,
                      }}
                    >
                      Hesap Bilgileri
                    </h4>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 8,
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: 12 }}>
                        e-Fatura Başlama Tarihi
                      </span>
                      <span style={{ fontSize: 12 }}>
                        {Util.formatDate(this.state.eInformation?.start_date)}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 8,
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: 12 }}>
                        Üyelik Başlangıç / Bitiş Tarihi
                      </span>
                      <span style={{ fontSize: 12 }}>
                        {Util.formatDate(this.state.company?.created_at)} /{" "}
                        {Util.formatDate(this.state.company?.expiry_date)}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: 12 }}>
                        Kalan Gün
                      </span>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: 18,
                          color: "#3598dc",
                        }}
                      >
                        {this.state.company?.expiryDays}
                      </span>
                    </div>
                    {(this.state.newCompanySettings &&
                      this.state.newCompanySettings.tax_identity_query !==
                        undefined
                        ? this.state.newCompanySettings.tax_identity_query
                        : this.state.currentCompanySettings.tax_identity_query !==
                            undefined
                          ? this.state.currentCompanySettings.tax_identity_query
                          : 1) === 1 ? (
                        <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ fontWeight: 600, fontSize: 12 }}>
                        Vkn Tckn Sorgulama Kontörünüz
                      </span>
                      <span style={{ fontSize: 12 }}>
                        {this.state.company?.tax_identity_query_balance}
                      </span>
                    </div>
                      ) : null}
                  </div>
                </div>
                {/* Kur Açıp Kapatma */}
                <div className={"col-md-4"} style={{ height: "138px" }}>
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{ fontWeight: 600, fontSize: 12, marginBottom: 8 }}
                    >
                      Döviz Kuru Gösterimi
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "currency_rate_visible",
                          e.target.value,
                        )
                      }
                      // Mantık: Yeni seçim varsa onu kullan (newCompanySettings), yoksa mevcut ayarı kullan
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.currency_rate_visible !==
                          undefined
                          ? this.state.newCompanySettings.currency_rate_visible
                          : this.state.currentCompanySettings
                              .currency_rate_visible
                      }
                    >
                      <option value={0}>Kapalı</option>
                      <option value={1}>Açık</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      Üst menüdeki anlık kur tablosunun görünürlüğünü belirler.
                    </div>
                  </div>
                </div>
                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{ fontWeight: 600, fontSize: 12, marginBottom: 8 }}
                    >
                      Stok Miktarı Ondalık Hane Sayısı
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "quantity_decimal_count",
                          e.target.value,
                        )
                      }
                      // Mantık: Yeni seçim varsa onu kullan (newCompanySettings), yoksa mevcut ayarı kullan
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.quantity_decimal_count !==
                          undefined
                          ? this.state.newCompanySettings.quantity_decimal_count
                          : this.state.currentCompanySettings
                              .quantity_decimal_count
                      }
                    >
                      <option value={0}>1 Hane</option>
                      <option value={1}>2 Hane</option>
                      <option value={2}>3 Hane</option>
                      <option value={3}>4 Hane</option>
                      <option value={4}>5 Hane</option>
                      <option value={5}>6 Hane</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      Ürün ve hizmet listelerindeki stok miktarlarının virgülden
                      sonra kaç basamak ile gösterileceğini belirler.
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-4"
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{ fontWeight: 600, fontSize: 12, marginBottom: 8 }}
                    >
                      Cari İsimlerinde TC/VKN Gösterimi
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "show_identity_number",
                          parseInt(e.target.value),
                        )
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.show_identity_number !==
                          undefined
                          ? this.state.newCompanySettings.show_identity_number
                          : this.state.currentCompanySettings
                                .show_identity_number !== undefined
                            ? this.state.currentCompanySettings
                                .show_identity_number
                            : 1
                      }
                    >
                      <option value={1}>Evet</option>
                      <option value={0}>Hayır</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      Müşteri ve tedarikçi seçimi yaparken listelerde isimlerin
                      yanında TC/VKN bilgisinin parantez içinde gösterilip
                      gösterilmeyeceğini belirler.
                    </div>
                  </div>
                </div>
                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Z Raporları Sayfası
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "show_z_reports",
                          parseInt(e.target.value),
                        )
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.show_z_reports !==
                          undefined
                          ? this.state.newCompanySettings.show_z_reports
                          : this.state.currentCompanySettings
                                .show_z_reports !== undefined
                            ? this.state.currentCompanySettings
                                .show_z_reports
                            : 1
                      }
                    >
                      <option value={1}>Açık</option>
                      <option value={0}>Kapalı</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      İşlemler menüsündeki Z Raporları sekmesinin görünürlüğünü
                      belirler.
                    </div>
                  </div>
                </div>

                {/* Teklifler/Siparişler */}
                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Teklifler ve Siparişler Sayfası
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "show_orders_quotes",
                          parseInt(e.target.value),
                        )
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.show_orders_quotes !==
                          undefined
                          ? this.state.newCompanySettings.show_orders_quotes
                          : this.state.currentCompanySettings
                                .show_orders_quotes !== undefined
                            ? this.state.currentCompanySettings
                                .show_orders_quotes
                            : 1
                      }
                    >
                      <option value={1}>Açık</option>
                      <option value={0}>Kapalı</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      İşlemler menüsündeki Teklifler ve Siparişler sekmesinin
                      görünürlüğünü belirler.
                    </div>
                  </div>
                </div>

                {/* Diğer Gelirler */}
                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Diğer Gelirler Sayfası
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "show_other_incomes",
                          parseInt(e.target.value),
                        )
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.show_other_incomes !==
                          undefined
                          ? this.state.newCompanySettings.show_other_incomes
                          : this.state.currentCompanySettings
                                .show_other_incomes !== undefined
                            ? this.state.currentCompanySettings
                                .show_other_incomes
                            : 1
                      }
                    >
                      <option value={1}>Açık</option>
                      <option value={0}>Kapalı</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      İşlemler menüsündeki Diğer Gelirler sekmesinin
                      görünürlüğünü belirler.
                    </div>
                  </div>
                </div>

                {/* Taşıma Sözleşmesi */}
                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Taşıma Sözleşmesi Sayfası
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "show_transportation_contract",
                          parseInt(e.target.value),
                        )
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.show_transportation_contract !==
                          undefined
                          ? this.state.newCompanySettings.show_transportation_contract
                          : this.state.currentCompanySettings
                                .show_transportation_contract !== undefined
                            ? this.state.currentCompanySettings
                                .show_transportation_contract
                            : 1
                      }
                    >
                      <option value={1}>Açık</option>
                      <option value={0}>Kapalı</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      İşlemler menüsündeki Taşıma Sözleşmesi sekmesinin
                      görünürlüğünü belirler.
                    </div>
                  </div>
                </div>

                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Personel Kendi İrsaliyelerini Görsün
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange(
                          "personnel_show_only_own_shipments",
                          parseInt(e.target.value, 10),
                        )
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings
                          .personnel_show_only_own_shipments !== undefined
                          ? this.state.newCompanySettings
                              .personnel_show_only_own_shipments
                          : this.state.currentCompanySettings
                                .personnel_show_only_own_shipments !== undefined
                            ? this.state.currentCompanySettings
                                .personnel_show_only_own_shipments
                            : 0
                      }
                    >
                      <option value={1}>Evet</option>
                      <option value={0}>Hayır</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      Personelin sadece kendi oluşturduğu irsaliyeleri görmesini
                      belirler.
                    </div>
                  </div>
                </div>

                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Tablo Satır Sayısı
                    </div>
                    <select
                      className={"form-control"}
                      onChange={(e) =>
                        this.onInputChange("size_per_page", parseInt(e.target.value, 10))
                      }
                      value={
                        this.state.newCompanySettings &&
                        this.state.newCompanySettings.size_per_page !== undefined
                          ? this.state.newCompanySettings.size_per_page
                          : this.state.currentCompanySettings.size_per_page !== undefined
                            ? this.state.currentCompanySettings.size_per_page
                            : 10
                      }
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={30}>30</option>
                      <option value={50}>50</option>
                    </select>
                    <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                      Liste ekranlarında sayfa başına gösterilecek satır sayısını
                      belirler.
                    </div>
                  </div>
                </div>

                <div
                  className={"col-md-4"}
                  style={{ height: "138px", marginTop: "10px" }}
                >
                  <div
                    style={{
                      border: "1px solid #e7ecf1",
                      borderRadius: 4,
                      padding: "15px 20px",
                      background: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      height: "138px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 12,
                        marginBottom: 8,
                      }}
                    >
                      Vkn Tckn Sorgulama Servisi
                    </div>
                    <div>
                      <select
                        className={"form-control"}
                        onChange={this.onTaxIdentityQuerySettingChange.bind(this)}
                        value={taxIdentityQueryValue}
                      >
                        <option value={1}>Açık</option>
                        <option value={0}>Kapalı</option>
                      </select>
                      <div style={{ fontSize: 11, color: "#888", marginTop: 10 }}>
                        {isTaxIdentityQueryEnabled ? (
                          <div>
                            <button
                              type="button"
                              className="btn btn-xs btn-primary"
                              style={{ marginTop: 8 }}
                              onClick={() => browserHistory.push("/subscriber")}
                            >
                              Kontör Al
                            </button>

                            <button
                              type="button"
                              className="btn btn-xs btn-default"
                              style={{ marginTop: 8, marginLeft: 8 }}
                              onClick={this.openTaxIdentityQueryLogModal.bind(this)}
                            >
                              Sorgulama Geçmişi
                            </button>

                            <div>Servisi kullanabilmek için kontor almalısınız</div>
                          </div>
                        ) : (
                          <div>Vkn Tckn Sorgulama Servisini Aç</div>
                        )}

                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            marginTop: 8,
                            cursor: isTaxIdentityQueryEnabled ? "not-allowed" : "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={
                              isTaxIdentityQueryEnabled ||
                              this.state.taxIdentityQueryAccepted === true
                            }
                            disabled={isTaxIdentityQueryEnabled}
                            onChange={(ev) =>
                              this.onTaxIdentityTermsCheckboxChange(
                                ev,
                                isTaxIdentityQueryEnabled,
                              )
                            }
                          />
                          <span onClick={this.openTaxIdentityTermsModal.bind(this)}>
                            Koşulları kabul ediyorum
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div
                style={{
                  float: "right",
                  marginTop: "-22px",
                }}
              >
                <EkoFormButton
                  label="Ayarları Kaydet"
                  faClass="fa fa-save"
                  onClick={this.onSaveForm.bind(this)}
                />
              </div>
            </EkoForm>
            <EkoModal
              showModal={this.state.taxIdentityTermsModal}
              title={"TC Kimlik No / Vergi Kimlik No Sorgulama Hizmeti Hakkında"}
              onHide={this.closeTaxIdentityTermsModal.bind(this)}
              spinner={false}
            >
              <div style={{ minHeight: 200 }}>
<p>Bu hizmet, Gelir İdaresi Başkanlığı'nın sunduğu resmi veri paylaşım sistemi üzerinden, TÜRMOB ile yapılan protokol kapsamında sağlanmaktadır. Sorgulama işlemlerine ilişkin ücretler, 578 Sıra No.lu Vergi Usul Kanunu Genel Tebliği ve ilgili düzenlemeler çerçevesinde belirlenmekte olup her yıl yeniden değerleme oranına göre güncellenmektedir. Ayrıca hizmetin sunulabilmesi için gerekli olan teknik altyapı, güvenlik, veri saklama ve işletim maliyetleri de dikkate alınarak ücretlendirme yapılmaktadır. Bu nedenle hizmet, satın alınan kontörler üzerinden kullandırılmaktadır.</p>
<p>Sorgulama sonucunda elde edilen bilgiler yalnızca mevzuatın izin verdiği amaçlar doğrultusunda kullanılmalıdır. Bu verilerin yetkisiz kişilerle paylaşılması, ticari amaçlarla çoğaltılması veya amacı dışında kullanılması halinde doğabilecek hukuki ve idari sorumluluk kullanıcıya aittir.</p>
<p>Bu hizmeti kullanarak; ücretlendirme esasları hakkında bilgilendirildiğinizi, elde edilen verileri yalnızca yasal amaçlarla kullanacağınızı ve ilgili mevzuata uygun hareket edeceğinizi kabul etmiş olursunuz.<br /><br />
Not: Gelir İdaresinin servisleri gereği Vkn Sorgusu 1 Kontör, TCKN sorgusu 2 Kontör olarak düşmektedir.</p>
<p>Yasal Dayanak : <a href="https://www.resmigazete.gov.tr/eskiler/2024/12/20241231-12.htm" target="_blank">https://www.resmigazete.gov.tr/eskiler/2024/12/20241231-12.htm</a></p>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button
                  type="button"
                  className="btn"
                  onClick={this.closeTaxIdentityTermsModal.bind(this)}
                >
                  İptal
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.acceptTaxIdentityTerms.bind(this)}
                >
                  KABUL EDİYORUM
                </button>
              </div>
            </EkoModal>
            <EkoModal
              showModal={this.state.taxIdentityQueryLogModal}
              title={"Vkn Tckn Sorgulama Geçmişi"}
              onHide={this.closeTaxIdentityQueryLogModal.bind(this)}
              spinner={false}
            >
              {this.state.taxIdentityQueryLogLoading ? (
                <div style={{ textAlign: "center", padding: "30px 0" }}>
                  <EkoSpinner />
                </div>
              ) : (
                <div>
                  {this.state.taxIdentityQueryLogList.length === 0 ? (
                    <div style={{ color: "#888" }}>Kayıt bulunamadı.</div>
                  ) : (
                    <div style={{ maxHeight: 420, overflowY: "auto" }}>
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>VKN/TCKN</th>
                            <th>Sorgu Tarihi</th>
                            <th>Harcanan Kontör</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.taxIdentityQueryLogList.map((row, idx) => (
                            <tr key={idx}>
                              <td>{row.tax_identity_number}</td>
                              <td>{Util.convertToDatabaseDateTime(row.query_date)}</td>
                              <td>{row.spent_credit}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </EkoModal>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    viewOptions: state.data.viewOptions,
  };
}
export default connect(mapStateToProps, actions)(SoftwareSettings);
